import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const localHost = apiUrl;

const endPoint = 'fetchTeams/';
const endPointTeam = 'fetchTeam/';
const linearEndPoint = 'fetchLinearTeams/';
const linearEndPointTeam = 'fetchLinearTeam/';

const url = localHost + endPoint;

export const fetchTeams = async ({
  OrgUUID,
}: {
  OrgUUID: string;
}): Promise<any | undefined> => {
  try {
    const res = await postWithAuth(url, {
      OrgUUID,
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const text = await res.json();
    const data = typeof text === 'string' ? JSON.parse(text) : text;
    return data;
  } catch (err) {
    console.error('Error fetching teams:', err);
    return undefined;
  }
};

export const fetchTeam = async ({
  TeamUUID,
  OrgUUID,
}: {
  TeamUUID: string;
  OrgUUID: string;
}): Promise<any | undefined> => {
  const url = localHost + endPointTeam;
  try {
    const res = await postWithAuth(url, {
      TeamUUID,
      OrgUUID,
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const text = await res.json();
    const data = typeof text === 'string' ? JSON.parse(text) : text;
    return data;
  } catch (err) {
    console.error('Error fetching team:', err);
    return undefined;
  }
};

export const fetchLinearTeams = async ({
  OrgUUID,
}: {
  OrgUUID: string;
}): Promise<any | undefined> => {
  const url = localHost + linearEndPoint;
  try {
    const res = await postWithAuth(url, {
      OrgUUID,
    });

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const text = await res.json();
    const data = typeof text === 'string' ? JSON.parse(text) : text;
    return data;
  } catch (err) {
    console.error('Error fetching teams:', err);
    return undefined;
  }
};

const fetchLinearTeam = async ({
  TeamUUID: LinearTeamUUID,
  OrgUUID,
  headerObj,
}: {
  TeamUUID: string;
  OrgUUID: string;
  headerObj?: headerObject;
}): Promise<any | undefined> => {
  const url = localHost + linearEndPointTeam;
  try {
    const res = await postWithAuth(
      url,
      {
        LinearTeamUUID,
        OrgUUID,
      },
      {
        headers: {
          ...headerObj,
        },
      }
    );

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const text = await res.json();
    const data = typeof text === 'string' ? JSON.parse(text) : text;
    return data;
  } catch (err) {
    console.error('Error fetching team:', err);
    return undefined;
  }
};
